
import React, { Component } from 'react';
import './index.css';
import './App.css';
import Menu from './Menu.js';
import Fade from './Fade.js';
import {HeaderInfo} from './HeaderInfo';
import Logo from './img/bubble.png';
import Cookies from 'universal-cookie';


export class LkWrapper extends Component {
    state = {
        isMobile: false,
        showMobileWarning: false
    }
    
    constructor(props) {
        super(props)
        this.props = props
        
        const cookies = new Cookies();
        //console.log("We are here ",cookies.get('clickanti_token'))
        var token = cookies.get('clickanti_token')

        if (!token || token === 'undefined')  {
            //alert('window location /auth')
            window.location = '/auth' //- раскомментируйте если нужно
        }
    }

    componentDidMount() {
        // Проверяем мобильное устройство при загрузке
        this.checkMobile();
        window.addEventListener('resize', this.checkMobile);
        
        // Показываем предупреждение для очень старых мобильных
        if (window.innerWidth < 320) {
            this.setState({ showMobileWarning: true });
        }
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.checkMobile);
    }

    checkMobile = () => {
        const isMobile = window.innerWidth <= 768;
        this.setState({ isMobile });
    }

    closeMobileWarning = () => {
        this.setState({ showMobileWarning: false });
    }

    render() {
        return (
            <div className={`fullPage lkWrapper ${this.state.isMobile ? 'mobile-view' : ''}`}>
                {/* Мобильное предупреждение (опционально) */}
                <Fade show={this.state.showMobileWarning}>
                    <div className='mobile-warning'>
                        <div style={{
                            background: '#fff3cd',
                            border: '1px solid #ffeaa7',
                            color: '#856404',
                            padding: '1em',
                            textAlign: 'center',
                            position: 'fixed',
                            top: 0,
                            left: 0,
                            right: 0,
                            zIndex: 1100,
                            fontSize: '0.9em'
                        }}>
                            Рекомендуем использовать приложение на устройствах с шириной экрана более 320px
                            <button 
                                onClick={this.closeMobileWarning}
                                style={{
                                    background: 'none',
                                    border: 'none',
                                    color: '#856404',
                                    marginLeft: '1em',
                                    cursor: 'pointer',
                                    fontSize: '1.2em'
                                }}
                            >
                                ✕
                            </button>
                        </div>
                    </div>
                </Fade>

                <Menu 
                    showCreatedDropdown={null} 
                    setShowCreatedDropdown={null}
                    showCreateDropdown={null} 
                    setShowCreateDropdown={null}
                    page={window.location.href.replace(process.env.REACT_APP_PANEL_SERVER, '')}
                />  

                <div className='fullPage_rightMainContent'> 
                    <HeaderInfo />
                    {/* Добавляем отступ сверху для мобильных */}
                    {this.state.isMobile && <div style={{height: '3em'}}></div>}
                    
                    {/*<Fade show={showSuccessMsg}>
                        <div className='successMessage'>
                            {successMsg}
                        </div>
                    </Fade>
                    
                    <Fade show={showErrorMsg}>
                        <div className='errorMessage'>
                            Ошибка: {errorMsg}
                        </div>
                    </Fade>
                    */}
                    
                    {/* Контент с адаптивными отступами */}
                    <div className={`content-wrapper ${this.state.isMobile ? 'mobile-content' : ''}`}>
                        {this.props.children}
                    </div>
                </div>
            </div>
        )
    }
}
